const setOptions = (payload, options) => {
  for (let key in options) {
    let option = options[key]
    payload[key] = option
  }
}

export default function (options) {

  let payload = {}
  setOptions(payload, options)

  payload.href = window.location.href
  payload.referringUrl = window.document.referrer

  return payload
}



// WEBPACK FOOTER //
// ./client/events/eventPayload.js